import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useGetEventFromEpg } from '../../../hooks/useGetEventFromEpg';

export const useHasReminder = contentInfo => {
  const [hasReminder, setHasReminder] = useState(false);
  const reminderList = useSelector(state => state.Player?.Reminder?.List.data);
  const epgChannels = useSelector(state => state.Player.EpgChannels.data);
 const { eventFromEpg } =  useGetEventFromEpg({contentInfo});

  //Este efecto busca si el evento tiene recordatorio
  useEffect(() => {
    const findChannel = epgChannels?.find(
      channelItem =>
        channelItem?.group_id === contentInfo?.id ||
        contentInfo?.channel_group_id,
    );
    const findEvent = findChannel?.events?.find(
      eventItem =>
        parseInt(eventItem?.id) ===
        parseInt(contentInfo.actual_event?.id || contentInfo?.id),
    );
    const foundReminder = reminderList?.find(
      reminderItem => reminderItem?.event_alf_id === contentInfo?.event_alf_id,
    );

    if (foundReminder) {
      setHasReminder(true);
    }
  }, []);
  return {
    hasReminder,
  };
};
